import React from 'react';
import type { Size } from '../../types';

const confirmed = (width: Size = '491', height: Size = '329') => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 491 329"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M189.762 64.7126C181.111 72.8261 147.059 69.4147 133.438 54.9394C119.817 40.4641 131.966 20.4569 140.525 12.3434C149.176 4.22986 167.122 9.39301 180.743 23.7761C194.363 38.3436 198.321 56.599 189.762 64.7126Z"
                fill="url(#paint0_linear_322_19075)"
            />
            <path
                d="M90.1823 58.3506C92.7591 63.2372 87.1452 78.1735 79.0464 82.5068C70.9476 86.8402 63.4009 79.0033 60.824 74.2089C58.2471 69.3223 62.6647 61.8542 70.8555 57.5208C79.0464 53.1875 87.6054 53.4641 90.1823 58.3506Z"
                fill="url(#paint1_linear_322_19075)"
            />
            <path
                d="M403.553 187.338C403.553 260.913 345.112 333.935 211.942 319.091C122.947 309.133 60.181 246.438 60.181 172.77C60.181 123.167 78.5874 79.9258 120.738 74.6704C141.169 72.1811 165.006 77.3442 199.149 97.3514C298.544 155.714 403.553 113.763 403.553 187.338Z"
                fill="url(#paint2_radial_322_19075)"
            />
            <path
                d="M152.027 279.353C150.186 253.537 175.403 240.721 179.36 215.92C182.489 191.026 165.463 176.09 151.751 157.558C134.357 133.678 140.062 99.8409 159.941 79.1883C32.2009 40.5568 21.8013 259.714 158.469 305.076C154.696 297.055 152.763 288.388 152.027 279.353Z"
                fill="url(#paint3_linear_322_19075)"
            />
            <path
                d="M105.735 264.416C107.3 262.296 108.68 259.991 109.876 257.686C110.337 256.303 110.705 254.827 110.981 253.352C111.257 248.742 111.073 244.132 110.613 239.522C108.312 225.693 103.894 212.324 100.397 198.77C93.8629 173.784 91.8382 147.969 98.0964 122.706C101.41 109.429 107.484 97.4434 116.319 87.0249C120.46 82.1383 125.89 77.8972 131.504 74.9468C131.688 74.8546 131.872 74.7624 132.056 74.6702C49.8716 74.0248 35.6066 200.153 101.594 269.211C102.974 267.643 104.355 266.076 105.735 264.416Z"
                fill="url(#paint4_linear_322_19075)"
            />
            <path
                d="M353.67 139.302C349.897 141.699 346.123 144.004 342.258 146.217C336.368 149.628 330.386 152.671 324.864 156.543C319.71 160.876 314.74 165.671 310.415 170.834C308.666 173.323 307.194 175.905 305.813 178.579C305.077 180.884 304.433 183.096 303.973 185.494C303.696 189.182 303.788 192.869 304.157 196.65C305.721 205.593 308.39 214.352 311.335 222.926C315.108 233.898 319.434 244.685 321.551 256.21C324.68 273.175 325.232 289.955 320.998 306.92C320.998 307.012 320.906 307.104 320.906 307.197C377.782 284.516 403.643 236.664 403.643 187.522C403.551 155.621 383.948 145.295 353.67 139.302Z"
                fill="url(#paint5_linear_322_19075)"
            />
            <path
                d="M370.602 266.26C364.712 255.196 374.835 222.742 391.217 213.891C407.599 205.04 424.072 223.203 429.962 234.267C435.852 245.331 427.386 261.373 411.004 270.224C394.622 279.076 376.492 277.232 370.602 266.26Z"
                fill="url(#paint6_linear_322_19075)"
            />
            <path
                d="M367.84 112.354L226.203 228.708C214.975 237.931 196.752 237.931 185.525 228.708L155.706 204.212L117.697 172.988L117.237 173.366C110.979 178.507 110.979 186.824 117.237 191.965L155.614 223.491L185.432 247.987C196.66 257.21 214.883 257.21 226.111 247.987L368.3 131.331C374.558 126.19 374.558 117.873 368.3 112.732L367.84 112.354Z"
                fill="#B7E803"
            />
            <path
                opacity="0.16"
                d="M367.84 112.354L226.203 228.708C214.975 237.931 196.752 237.931 185.525 228.708L155.706 204.212L117.697 172.988L117.237 173.366C110.979 178.507 110.979 186.824 117.237 191.965L155.614 223.491L185.432 247.987C196.66 257.21 214.883 257.21 226.111 247.987L368.3 131.331C374.558 126.19 374.558 117.873 368.3 112.732L367.84 112.354Z"
                fill="url(#paint7_linear_322_19075)"
            />
            <path
                d="M185.616 228.708C196.844 237.932 215.066 237.932 226.294 228.708L367.932 112.354L340.874 90.127C334.616 84.986 324.493 84.986 318.234 90.127L212.213 177.146C208.716 180.019 203.102 180.019 199.605 177.146L167.486 150.761C161.228 145.62 151.104 145.62 144.846 150.761L117.789 172.988L155.798 204.212L185.616 228.708Z"
                fill="url(#paint8_linear_322_19075)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_322_19075"
                    x1="127.29"
                    y1="38.7857"
                    x2="194.277"
                    y2="38.7857"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A4E9D9" />
                    <stop offset="0.4009" stopColor="#81D7CC" />
                    <stop offset="0.7779" stopColor="#66C9C3" />
                    <stop offset="1" stopColor="#5CC4BF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_322_19075"
                    x1="60.086"
                    y1="69.064"
                    x2="90.8682"
                    y2="69.064"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A4E9D9" />
                    <stop offset="0.4009" stopColor="#81D7CC" />
                    <stop offset="0.7779" stopColor="#66C9C3" />
                    <stop offset="1" stopColor="#5CC4BF" />
                </linearGradient>
                <radialGradient
                    id="paint2_radial_322_19075"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(219.08 258.377) scale(234.999 235.426)"
                >
                    <stop stopColor="#5CC4BF" />
                    <stop offset="0.2221" stopColor="#66C9C3" />
                    <stop offset="0.5991" stopColor="#81D7CC" />
                    <stop offset="1" stopColor="#A4E9D9" />
                </radialGradient>
                <linearGradient
                    id="paint3_linear_322_19075"
                    x1="57.8677"
                    y1="178.948"
                    x2="182.108"
                    y2="194.095"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A4E9D9" />
                    <stop offset="0.4009" stopColor="#81D7CC" />
                    <stop offset="0.7779" stopColor="#66C9C3" />
                    <stop offset="1" stopColor="#5CC4BF" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_322_19075"
                    x1="165.874"
                    y1="218.35"
                    x2="2.3236"
                    y2="64.2676"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A4E9D9" />
                    <stop offset="0.4009" stopColor="#81D7CC" />
                    <stop offset="0.7779" stopColor="#66C9C3" />
                    <stop offset="1" stopColor="#5CC4BF" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_322_19075"
                    x1="460.367"
                    y1="287.901"
                    x2="314.706"
                    y2="207.712"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A4E9D9" />
                    <stop offset="0.4009" stopColor="#81D7CC" />
                    <stop offset="0.7779" stopColor="#66C9C3" />
                    <stop offset="1" stopColor="#5CC4BF" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_322_19075"
                    x1="368.892"
                    y1="243.683"
                    x2="431.876"
                    y2="243.683"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A4E9D9" />
                    <stop offset="0.4009" stopColor="#81D7CC" />
                    <stop offset="0.7779" stopColor="#66C9C3" />
                    <stop offset="1" stopColor="#5CC4BF" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_322_19075"
                    x1="112.667"
                    y1="183.64"
                    x2="372.989"
                    y2="183.64"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3BBFFF" />
                    <stop offset="0.2913" stopColor="#2F93F0" />
                    <stop offset="0.6027" stopColor="#256BE2" />
                    <stop offset="0.8498" stopColor="#1E52D9" />
                    <stop offset="1" stopColor="#1C49D6" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_322_19075"
                    x1="128.941"
                    y1="174.652"
                    x2="347.428"
                    y2="186.013"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D5F364" />
                    <stop offset="1" stopColor="#B7E803" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default confirmed;
